import { useAppRouter } from '@zorro/web/ui-utils';

import {
  AddEmployerStep,
  AddEmployerStepType,
  HandleStepSubmit,
} from '../AddEmployerStep';
import { PaymentAccountDetailsForm } from './PaymentAccountDetailsForm';
import { usePaymentAccountDetailsForm } from './usePaymentAccountDetailsForm';

type Props = {
  employerId: string;
  isFinalizationMode: boolean;
  isReadOnlyMode: boolean;
};

export const AddPaymentAccountDetailsStep = ({
  employerId,
  isFinalizationMode,
  isReadOnlyMode,
}: Props) => {
  const { navigateToRoute } = useAppRouter();
  const {
    form,
    onSubmit: onPaymentsFormSubmit,
    isSubmitting,
    submitLabel,
    navigateTo,
  } = usePaymentAccountDetailsForm({
    employerId,
  });

  const handleStepSubmit: HandleStepSubmit = async () => {
    const success = await onPaymentsFormSubmit();
    if (success && navigateTo) {
      navigateToRoute(navigateTo, [employerId]);
    }
    return { navigate: false };
  };

  const isSubmitDisabled =
    isReadOnlyMode || !form.formState.isValid || isSubmitting;

  return (
    <AddEmployerStep
      isSubmitDisabled={isSubmitDisabled}
      isFinalizationMode={isFinalizationMode}
      step={AddEmployerStepType.FINALIZE}
      title="Finalize Lynx setup"
      submitLabel={submitLabel}
      employerId={employerId}
      onSubmit={handleStepSubmit}
      isDon={false}
    >
      <PaymentAccountDetailsForm
        form={form}
        isReadOnly={isReadOnlyMode}
        employerId={employerId}
      />
    </AddEmployerStep>
  );
};
